"use client"
import { Card } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { imageUrl } from '@/util/api/baseUrl';
import ProductList from '@/util/view/ProductList';
import { ProductPageType } from '../products/product';
import MyImage from '@/util/view/MyImage';
import { Carousel, CarouselContent } from '@/components/ui/carousel';
import { EssenceType, ProductEssenceType } from './type';
import ProductEssenceList from './ProductEssenceList';



interface Props {
    data: EssenceType
    products: ProductEssenceType
}

const EssenceView = ({ data, products }: Props) => {
    const { data: essence } = data
    return (
        <div>
            <div className='mx-auto my-5 text-center table'>
                <h1 className='font-bold text-2xl'>اسانس {essence.essence_title}</h1>
                <h2 className='text-xl'>{essence.essence_second_title} essence</h2>
                <MyImage alt={essence.essence_image_alt} src={essence.essence_image} height={200} width={200} classImage='rounded-[50%] border border-ebony p-1' />
            </div>
            {
                products?.data?.rows[0] ?
                    <div>
                        <Separator className='my-4' />
                        <ProductEssenceList data={products} title={`محصولات با اسانس ${essence.essence_title}`} />
                    </div> : null
            }
            {
                essence.essence_description ? <div>
                    <Separator className='my-4' />
                    <Card className="">
                        <div className="p-5" dangerouslySetInnerHTML={{ __html: essence.essence_description }} />
                    </Card>
                </div> : null
            }

        </div>
    )
}

export default EssenceView